<template>
  <div>
    <base-header class="bg-vg-gradient pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col-xl-12">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center justify-content-between m-1">
                <div class="col-lg-6 col-xs-12">
                  <p class="mb-0"><span style="font-weight: bold">İlan:</span> {{ this.jobInformation.job.title }}</p>
                  <p class="mb-0"><span style="font-weight: bold">İlan Sonuç Aşaması:</span>
                    {{ this.jobInformation.name }}</p>
                </div>
                <div class="row">
                  <div class="col-6">
                    <a :href="`${api_url}company/excel-example-download/${this.$route.params.id}?token=${token}`"
                       target="_blank">
                      <el-button size="small" type="success" id="button-excel" class="is-plain mr-1">Excel Şablonu
                        İndir
                      </el-button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body pt-0 pt-md-4" v-loading="loading">
              <div class="col-12 pb-5">
                <div class="text-center mt-2">
                  <company-file @readExcelFile="readExcelFile" :jobStatusTypeId="this.$route.params.id"></company-file>
                </div>
              </div>

              <div class="col-12 table-responsive" v-if="excelData !== null">
                <vue-good-table
                    title=""
                    :columns="columns"
                    :rows="excelData"
                    :paginate="true"
                    :lineNumbers="true"
                    :globalSearch="true"
                    :search-options="{enabled: true,placeholder: 'Ara'}"
                    :sort-options="{enabled:false}"
                    :pagination-options="{
                      enabled: true,
                      mode: 'records',
                      nextLabel: 'İleri',
                      prevLabel: 'Geri',
                      rowsPerPageLabel: 'Sayfa başı sonuç',
                      pageLabel: 'Sayfa', // for 'pages' mode
                      allLabel: 'Hepsi',
                      ofLabel:'kişi',
                      perPage:5
                    }"
                    styleClass="table table-bordered table-striped"
                />
              </div>

              <div class="col-12 text-right mt-2" v-if="excelData !== null && errorCandidates == null">
                <el-button type="success" @click="confirmDialog = true">İlan Sonuçlarını Açıkla</el-button>
              </div>


              <div class="col-12 table-responsive" v-if="errorCandidates !== null && excelData == null">
                <vue-good-table
                    title=""
                    :columns="errorCandidatesColumns"
                    :rows="errorCandidates"
                    :paginate="true"
                    :lineNumbers="true"
                    :globalSearch="true"
                    :search-options="{enabled: true,placeholder: 'Ara'}"
                    :sort-options="{enabled:false}"
                    :pagination-options="{
                      enabled: true,
                      mode: 'records',
                      nextLabel: 'İleri',
                      prevLabel: 'Geri',
                      rowsPerPageLabel: 'Sayfa başı sonuç',
                      pageLabel: 'Sayfa', // for 'pages' mode
                      allLabel: 'Hepsi',
                      ofLabel:'kişi',
                      perPage:5
                    }"
                    styleClass="table table-bordered table-striped"
                />
              </div>
            </div>
          </div>

          <el-dialog
              title="İlan sonuç aşamasına kişi aktarımı yapıyorsunuz"
              :visible.sync="confirmDialog">
            <span>"{{this.jobInformation.job.title}}" ilanı "{{this.jobInformation.name}}" ilan sonuç aşamasına {{ excelDataCount }} kişi aktarıyorsunuz.</span>
            <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="confirmDialog = false">Vazgeç</el-button>
             <el-button type="danger" size="small"
                        @click="saveFile(), confirmDialog = false">Kişi aktarımını onayla.</el-button>
    </span>
          </el-dialog>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {env} from "@/environments/env";
import CompanyFile from "@/components/CompanyFile";
import readXlsxFile from 'read-excel-file'
import * as axios from "axios";
import Vue from 'vue';
import VueGoodTable from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'

Vue.use(VueGoodTable);
export default {
  name: "ImportExcel",
  components: {
    CompanyFile,
    //VuePhoneNumberInput
    // eslint-disable-next-line vue/no-unused-components
    readXlsxFile
  },
  created() {
    this.getJobInformation()
  },
  data() {
    return {
      token: localStorage.getItem('access_token'),
      site_url: env.SITE_URL,
      api_url: env.API_URL,
      loading: true,
      file: null,
      excelData: null,
      confirmDialog: false,
      excelDataCount: 0,
      currentPage: 1,
      currentPageSize: 1,
      errorCandidates: null,
      jobInformation: null,
      errorCandidatesColumns: [
        {
          label: 'Başvuru Id',
          field: 'application_id',
          type: 'number',
          html: false,
          filterable: true,
        },
        {
          label: 'İsim Soyisim',
          field: 'name',
          filterable: true,
        },
        {
          label: 'T.C Kimlik Numarası',
          field: 'identity_number',
          type: 'number',
          html: false,
          filterable: true,
        },
        {
          label: 'Mesaj',
          field: 'error',
          html: false,
          filterable: true,
        },
        // {
        //   label: 'job_status_type_id',
        //   field: 'job_status_type_id',
        //   type: 'number',
        //   html: false,
        //   filterable: true,
        // },

      ],
      columns: [
        {
          label: 'Başvuru Id',
          field: 'basvuru_id',
          type: 'number',
          html: false,
          filterable: true,
        },
        {
          label: 'İsim Soyisim',
          field: 'ad_soyad',
          filterable: true,
        },
        {
          label: 'T.C Kimlik Numarası',
          field: 'tc',
          type: 'number',
          html: false,
          filterable: true,
        },
        // {
        //   label: 'job_status_type_id',
        //   field: 'job_status_type_id',
        //   type: 'number',
        //   html: false,
        //   filterable: true,
        // },

      ],
    }
  },
  methods: {
    async readExcelFile(file) {
      this.loading = true;
      this.file = file;
      let formData = new FormData();
      formData.append('file', file);
      formData.append('job_status_type_id', this.$route.params.id);
      console.log(this.file, this.$route.params.id)

      //console.log(formData);
      await axios.post('company/excel-import', formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
        // excel verisini mapler
        console.log(response.data,"response");
        const map = {
          'basvuru_id': 'basvuru_id',
          'ad_soyad': 'ad_soyad',
          'tc': 'tc',
        }
        readXlsxFile(this.file, {map}).then(({rows}) => {
          this.excelData = rows;
          this.excelDataCount = rows.length;
          this.errorCandidates = null;
        })
      })
          .catch((err) => {
            this.errorCandidates = err.response.data.error_candidates;
            this.excelData = null;
            let errorMessage = null;
            if (err.response.data.error_messages == null) {
              errorMessage = 'Excel dosyasında hatalı veriler var. Aşağıdan görebilirsiniz.';
            } else {
              errorMessage = err.response.data.error_messages.error;
            }
            if (err.response.status === 500) {
              this.$notify.error({
                title: errorMessage,
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getJobInformation() {
      axios.get('company/job-status-type-excel/' + this.$route.params.id).then(response => {
        this.jobInformation = response.data;
        this.loading = false;
      })
          .catch(() => {
            this.loading = false;
            this.$notify.error({
              title: 'Veriler yüklenirken bir hata meydana geldi. Daha sonra tekrar deneyiniz.',
            });
          });
    },
    async saveFile() {
      this.loading = true;
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('job_status_type_id', this.$route.params.id);
      await axios.post('company/excel-import-save', formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
        if (response.status === 200) {
          this.$notify.success({
            title: 'Başarılı',
            message: 'Bilgi güncellemesi başarıyla gerçekleştirildi.',
          });

          this.$router.push({path: `/job-result-stage-candidates/${this.$route.params.id}/${this.jobInformation.job.id}`})

        }
      })
          .catch((err) => {
            if (err.response.status === 500) {
              console.log(err.response.data.error)
              this.$notify.error({
                title: 'Bir hata meydana geldi. Lütden excel dosyanızı kontrol ediniz.',
              });
            }
          })
          .finally(() => {
            this.removeImage();
            this.excelData = null;
            this.excelDataCount = 0;
            this.errorCandidates = null;
            this.loading = false;
          });
    },
    removeImage() {
      this.dialogVisible = false
      this.img_url = null;
      this.file = null;
      this.key_path = [];
    }
  },
}
</script>

<style scoped>

table, th, td, tr {
  width: 100% !important;
}

th {
  width: 100% !important;

}

td {
  width: 100% !important;
}
</style>